import { Portal } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Portal>;
export const DropdownPortal = (props: Props) => {
    return <Portal {...props} />;
};
